module.exports = __webpack_public_path__ + "img/zsy_icon_01.457e2d60.png";